import { BoxProps } from '@material-ui/core';
import { Holder, HolderType } from '@nemuru-eng/js-api-client';

import { HolderDetailsEditDialog } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/Holders/components/HolderDetailsEditDialog';
import { HolderDetailsForm } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/Holders/components/HolderDetailsForm';
import { useBusinessDetailsActions } from '@/components/modules/KYC/KYCLoan/BusinessKYC/hooks/useBusinessDetailsActions';
import { useBusinessKyc } from '@/components/modules/KYC/KYCLoan/BusinessKYC/hooks/useBusinessKyc';
import { BusinessActions } from '@/components/modules/KYC/KYCLoan/BusinessKYC/types/BusinessActions';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';

interface HoldersDetailsProps {
  loanId: string;
  id: string;
  holder: Holder;
  holderType: HolderType;
  index: number;
  editModeAllowed?: boolean;
  boxProps?: BoxProps;
}

export const HoldersDetails = ({
  loanId,
  id,
  holder,
  holderType,
  index,
  editModeAllowed,
  boxProps,
}: HoldersDetailsProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();

  const { getTextIdTranslation } = useTranslation();
  const { dialogAction, toggleEditModeDialog, businessBaseActionsOptions } = useBusinessDetailsActions({
    editModeAllowed,
    businessOnboarding: holder,
    toggleDialog,
  });
  const { setHoldersToBusinessOnboardingDetails, loading } = useBusinessKyc({ loanId });

  return (
    <SubSectionWrapper
      {...boxProps}
      title={`${getTextIdTranslation(holderType)} #${index + 1}`}
      specificActionsOptionsArray={toggleEditModeDialog ? businessBaseActionsOptions : undefined}
    >
      <>
        <HolderDetailsForm holder={holder} type={holderType} fieldVariant={FieldVariant.dataRow} />
        {opened && dialogAction === BusinessActions.EDIT_DIALOG && (
          <HolderDetailsEditDialog
            id={id}
            holderType={holderType}
            holder={holder}
            opened={opened}
            setOpened={setOpened}
            toggleDialog={toggleDialog}
            setHoldersToBusinessOnboardingDetails={setHoldersToBusinessOnboardingDetails}
            loading={loading}
          />
        )}
      </>
    </SubSectionWrapper>
  );
};
